import React, { useState } from 'react';
import styles from './TopBanner.module.css';
import { BsInfoCircle, BsX } from 'react-icons/bs';

const TopBanner = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const openModal = () => setIsModalOpen(true);
    const closeModal = () => setIsModalOpen(false);

    return (
        <>
            <div className={styles.bannerContainer} onClick={openModal} style={{ cursor: 'pointer' }}>
                <div className={styles.adLabel}>광고</div>
                <div className={styles.adContent}>
                    <BsInfoCircle size={14} color="#adb5bd" />
                    <span>여행 준비가 쉬워지는 <span className={styles.adLink}>TokPlan 사용법</span> 지금 만나보세요</span>
                </div>
            </div>

            {isModalOpen && (
                <div className={styles.modalOverlay} onClick={closeModal}>
                    <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
                        <button className={styles.closeButton} onClick={closeModal}>
                            <BsX size={24} />
                        </button>
                        <div className={styles.videoWrapper}>
                            <iframe
                                width="100%"
                                height="100%"
                                src="https://www.youtube.com/embed/8fbBQIOqIK0?autoplay=1"
                                title="TokPlan Tutorial"
                                frameBorder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen
                            ></iframe>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default TopBanner;
